/**
 * Shared class label formatter (Web) — keep in sync with backend classDisplay.util.js
 */
export function getClassDisplayLabel(cls) {
  if (!cls) return "";
  const className = cls?.name || cls?.className || "";
  const section = cls?.section || cls?.classSection || cls?.division || "";
  if (!className) return section || "";
  return section ? `${className} - ${section}` : className;
}

export function getClassDisplayFromStudent(student) {
  if (!student) return "";
  const cls = student.Class || student.class || student;
  return getClassDisplayLabel(cls);
}

/** Unique formatted labels, e.g. ["SE - A", "TE - B"]. */
export function collectClassDisplayLabels(entries, getLabel) {
  const labels = new Set();
  (entries || []).forEach((entry) => {
    const label = typeof getLabel === "function" ? getLabel(entry) : "";
    if (label && String(label).trim()) labels.add(String(label).trim());
  });
  return [...labels].sort((a, b) => a.localeCompare(b));
}

export function formatClassLabelList(labels) {
  const list = Array.isArray(labels) ? labels.filter(Boolean) : [];
  if (!list.length) return "";
  if (list.length === 1) return list[0];
  if (list.length === 2) return `${list[0]} and ${list[1]}`;
  return `${list.slice(0, -1).join(", ")}, and ${list[list.length - 1]}`;
}
